import script from "./ColorScapeScene.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorScapeScene.vue?vue&type=script&setup=true&lang=js"

import "./ColorScapeScene.vue?vue&type=style&index=0&id=0111ea0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0111ea0c"]])

export default __exports__